import { queryGraphQL } from 'common/util/query';
import { nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';
import { get, map } from 'lodash';
import { addApplicationMessages, addApplicationMessage } from 'common/actions/applicationMessagesActions';
export const ACTIONS = {
    USER_BINDERS_LOADING: 'USER_BINDERS_LOADING',
    USER_BINDERS_LOAD: 'USER_BINDERS_LOAD',
    USER_BINDERS_LOADED: 'USER_BINDERS_LOADED',
    USER_BINDERS_RESET: 'USER_BINDERS_RESET',
    USER_BINDERS_SELECTED: 'USER_BINDERS_SELECTED',
    ADD_USER_TO_BINDERS: 'ADD_USER_TO_BINDERS',
    ADD_USER_TO_BINDERS_REQUEST: 'ADD_USER_TO_BINDERS_REQUEST',
    ADD_USER_TO_BINDERS_SUCCESS: 'ADD_USER_TO_BINDERS_SUCCESS',
    ADD_USER_TO_BINDERS_FAILURE: 'ADD_USER_TO_BINDERS_FAILURE',
    ADD_USER_TO_BINDER_AS_ADMIN: 'ADD_USER_TO_BINDER_AS_ADMIN',
    ADD_USER_TO_BINDER_AS_ADMIN_REQUEST: 'ADD_USER_TO_BINDER_AS_ADMIN_REQUEST',
    ADD_USER_TO_BINDER_AS_ADMIN_FAILURE: 'ADD_USER_TO_BINDER_AS_ADMIN_FAILURE',
    USER_BINDERS_MODAL_SHOW: 'USER_BINDERS_MODAL_SHOW',
    USER_BINDERS_ROW_CHECKED: 'USER_BINDERS_ROW_CHECKED'
};

export function loadUserBinders(institutionId, targetUserId) {
    return async dispatch => {
        dispatch(loadingUserBinders());
        const availableBindersNode = nodeWithArgs('getAvailableBindersForUser', {
            targetUserId,
            institutionId,
        }, [
            'id',
            'name',
            'principalInvestigator',
            'site'
        ]);
        const response = await queryGraphQL(toQuery(availableBindersNode));
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(loadedUserBinders());
            return;
        }
        dispatch({
            type: ACTIONS.USER_BINDERS_LOAD,
            payload: {
                data: get(response, 'data.getAvailableBindersForUser', []),
            }
        });
    };
}

export function loadingUserBinders() {
    return { type: ACTIONS.USER_BINDERS_LOADING };
}

export function loadedUserBinders() {
    return { type: ACTIONS.USER_BINDERS_LOADED };
}

export function resetUserBinders() {
    return {
        type: ACTIONS.USER_BINDERS_RESET,
        payload: {
            isLoading: false,
            error: { isPresent: false, message: null }
        }
    };
}

export function addUserToBinders(institutionId, userId, binderIds) {
    return async dispatch => {
        dispatch(addUserToBindersRequest());
        const mutation = toMutation(
            nodeWithArgs('addUserToBinders', {
                institutionId,
                userId,
                binderIds
            },[
                'id',
                'name',
                'principalInvestigator',
                'site'
            ])
        );
        const response = await queryGraphQL(mutation);
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(addUserToBindersFailure(response.errors));
            return;
        }
        dispatch({
            type: ACTIONS.ADD_USER_TO_BINDERS,
            payload: {
                data: get(response, 'data.addUserToBinders', []),
            }
        });
        dispatch(addApplicationMessage('success', 'Bulk adding user to binders succeeded'));
    };
}

export function addUserToBindersRequest() {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_REQUEST,
    };
}

export function addUserToBindersSuccess(responseData) {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_SUCCESS,
        payload: {
            user: responseData,
        }
    };
}

export function addUserToBindersFailure(error) {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_FAILURE,
        payload: {
            error: error
        }
    };
}

export function setSelectedBinders(selectedBinderIds) {
    return {
        type: ACTIONS.USER_BINDERS_SELECTED,
        payload: {
            selectedBinderIds
        }
    };
}

export function setRowChecked(data) {
    return {
        type: ACTIONS.USER_BINDERS_ROW_CHECKED,
        payload: {
            data
        }
    };
}

export function setShowModal(show) {
    return {
        type: ACTIONS.USER_BINDERS_MODAL_SHOW,
        payload: {
            show
        }
    };
}

export function addUserToBinderAsAdmin(institutionId, userId, binderIds) {
    return async dispatch => {
        dispatch({ type: ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN_REQUEST });
        const results = [];
        const errors = [];
        for (const binderId of binderIds) {
            const mutation = toMutation(
                nodeWithArgs('addUserToBinderAsAdmin', {
                    institutionId,
                    userId,
                    binderId
                }, [
                    'id',
                    'name',
                    'principalInvestigator',
                    'site',
                    'studyId',
                    'studyUserType'
                ])
            );
            const response = await queryGraphQL(mutation);
            if (response.errors) {
                errors.push(...map(response.errors, 'message'));
            } else {
                const data = get(response, 'data.addUserToBinderAsAdmin', null);
                if (data) results.push(data);
            }
        }
        if (errors.length) {
            dispatch(addApplicationMessages('error', errors));
        }
        if (results.length) {
            dispatch({
                type: ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN,
                payload: { data: results },
            });
            dispatch(addApplicationMessage('success', `Added user as admin to ${results.length} binder(s)`));
        } else if (!errors.length) {
            dispatch({ type: ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN_FAILURE, payload: { error: 'No binders added' } });
        }
    };
}
